<template>
  <div>
      <b-row>
          <b-col>
              <h4>{{number}}</h4>
          </b-col>
          <b-col class="text-right">
              <b-button variant="outline-primary" pill @click="callKnowlarity">Make a call</b-button>
          </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
props: {
    number: String
},
methods: {
    callKnowlarity() {
        //{ number: this.number }
      this.$store.dispatch('callKnowlarity', { number: this.number }).then(()=> {
          this.$bvToast.toast('call has been triggered', {
            title: 'Call Placed.',
            autoHideDelay: 5000,
            variant: 'success'
        })
      }).catch(()=>{
          this.$bvToast.toast('unable to place call', {
            title: 'Fatal',
            autoHideDelay: 5000,
            variant: 'danger'
        })
      })
    },
}
}
</script>

<style>

</style>